<template>
  <div
    v-if="showPlaneLoader"
    class="loader"
  >
    <div class="inner">
      <img
        src="~assets/images/loader/plane.svg"
        alt="AirBaltic"
        :width="getDimension"
        :height="getDimension"
      >
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    computed: {
      getDimension () {
        if (this.isMobile) {
          return 146
        }

        if (this.isTablet) {
          return 215
        }

        return 320
      },
      ...mapState('main', [
        'showPlaneLoader'
      ]),
      ...mapGetters('device', [
        'isMobile',
        'isTablet'
      ])
    }
  }

</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";
  @import "~assets/styles/keyframes.scss";

  .loader {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(11, 11, 11, .8);
    text-align: center;
  }

  .inner {
    display: inline-block;
    margin: 0 auto;
    width: auto;

    img {
      animation: spin 1.5s linear infinite;
    }
  }
</style>
